import {
  HubConnection,
  HubConnectionBuilder,
  IHttpConnectionOptions,
  HttpTransportType
} from "@microsoft/signalr";
import { SignalRUtilities } from "./sqe-signalr";

export class Comms {
  private _jwt = "";
  private _apiAddress: string;
  private _signalConnectionsSettings: IHttpConnectionOptions = {
    logMessageContent: false,
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets
  };

  public sqeComms: SignalRUtilities | null = null;
  private _connection: HubConnection | null = null;

  constructor(apiAddress: string | null, jwt: string | null) {
    this._apiAddress = apiAddress
      ? apiAddress
      : "http://localhost:5000/signalr";

    if (jwt !== null) this.setJwt(jwt);
    else this.startConnection();
  }

  public async setJwt(jwt: string): Promise<boolean> {
    this._jwt = jwt
    try {
      if (this._jwt !== "")
        this._signalConnectionsSettings = {
          ...this._signalConnectionsSettings,
          accessTokenFactory: () => this._jwt
        };
      else
        this._signalConnectionsSettings = {
          logMessageContent: false,
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets
        };
      await this.startConnection()
      return true
    } catch {
      return false
    }
  }

  public async setApiAddress(api: string) {
    this._apiAddress = api;
    await this.startConnection();
  }

  public async startConnection() {
    if (this._apiAddress !== "") {
      if (this._connection) await this._connection.stop();
      this._connection = new HubConnectionBuilder()
        .withUrl(this._apiAddress, this._signalConnectionsSettings)
        .withAutomaticReconnect()
        .build();
      await this._connection.start();
      this.sqeComms = new SignalRUtilities(this._connection);
    } else {
      this._connection = null;
      this.sqeComms = null;
    }
  }

  public async stopConnection() {
    if (this._connection) await this._connection.stop();
  }
}
